import { z } from 'zod';

/**
 * ID delle 12 classi di Dungeon World Rebrewed.
 * Riferimento: docs/manual/MANUAL_ANALYSIS.md §2.
 */
export const ClassIdSchema = z.enum([
  'barbaro',
  'bardo',
  'chierico',
  'druido',
  'guerriero',
  'ladro',
  'mago',
  'monaco',
  'paladino',
  'ranger',
  'sciamano',
  'warlock',
]);
export type ClassId = z.infer<typeof ClassIdSchema>;

/** Lista ordinata degli ID classe (utile per UI / iterazione). */
export const CLASS_IDS = ClassIdSchema.options;

/**
 * Sottoinsieme delle classi che lanciano incantesimi (mosse *Lanciare
 * Incantesimi Arcani/Divini/del Patrono* + *Mana*).
 *
 * Lo Sciamano usa una mistica diversa (Aldilà, spiriti, costi narrativi)
 * e NON è una classe casteggiante in senso PbtA-DWR: niente *Mana*, niente
 * spell list, niente Tradizioni. Per coerenza, NON va incluso qui.
 */
export const SPELLCASTING_CLASS_IDS = [
  'mago',
  'chierico',
  'druido',
  'warlock',
  'paladino',
] as const satisfies readonly ClassId[];
